// We round numbers like this instead of using formatting method toFixed() which can round incorrectly some numbers
// 1.005.toFixed(2) = 1.00 while it should be rounded to 1.01
export const roundAmount = (numberToRound: number, nbDigits: number) =>
    Math.round((numberToRound + Number.EPSILON) * Math.pow(10, nbDigits)) / Math.pow(10, nbDigits);

// Floating vs Decimals: https://floating-point-gui.de/basic/
export const getExactDecimalValue = (floatingNumber: number, nbDigits: number) =>
    Number(floatingNumber.toFixed(nbDigits));
